// removed by extract-text-webpack-plugin
module.exports = {"ListItem":"_I3nt2","ListItemActive":"_3-7Cf","Dot":"_3aUA7","DotActive":"_1D_wQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/TupleHeader/Dropdown/Dropdown.scss
// module id = 712
// module chunks = 0